import React from 'react';
import { hasDiscountNodeCost, type NodeCostInfo } from '$/store/useTeamFlowStore';
import styles from './index.module.scss';

interface RadishCostTextProps {
  /** 原价 */
  cost?: number | string | null;
  /** 折扣价 */
  discountCost?: number | null;
  className?: string;
}

/**
 * 萝卜消耗文案：有折扣时展示「折扣价/原价」，原价带删除线。
 *
 * @param {RadishCostTextProps} props
 * @return {React.ReactElement | null}
 */
export default function RadishCostText({
  cost,
  discountCost,
  className,
}: RadishCostTextProps) {
  if (cost === undefined || cost === null || cost === '') {
    return null;
  }
  const numericCost = Number(cost);
  if (Number.isNaN(numericCost)) {
    return <span className={className}>{cost}</span>;
  }
  const info: NodeCostInfo = {
    cost: numericCost,
    ...(typeof discountCost === 'number' ? { discount_cost: discountCost } : {}),
  };
  if (hasDiscountNodeCost(info)) {
    return (
      <span className={className || styles.radishCost}>
        <span>{discountCost}</span>
        <span>/</span>
        <span className={styles.originalCost}>{numericCost}</span>
      </span>
    );
  }
  return <span className={className}>{numericCost}</span>;
}
